var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pie-chart',{attrs:{"chart-data":_vm.chartData,"chart-id":_vm.chartId,"height":_vm.height,"flip-page":false,"legend-position":"right"}})
}
var staticRenderFns = []

export { render, staticRenderFns }